import { Button, CircularProgress, ButtonProps } from '@mui/material';
import { memo } from 'react';

interface FormButtonProps extends ButtonProps {
  isSubmitting?: boolean;
  isDirty?: boolean;
  label: string;
}

const FormButton = memo(
  ({ isSubmitting, isDirty, label, onClick, ...props }: FormButtonProps) => {
    return (
      <Button
        variant="contained"
        disabled={!isDirty || isSubmitting}
        onClick={onClick}
        sx={{
          minWidth: 120,
          position: 'relative',
          bgcolor: isDirty ? 'primary.main' : 'grey.300',
          '&:hover': {
            bgcolor: isDirty ? 'primary.dark' : 'grey.300',
          },
          '&.Mui-disabled': {
            bgcolor: 'grey.300',
            color: 'grey.500',
          },
        }}
        {...props}
      >
        {isSubmitting ? (
          <>
            <CircularProgress
              size={24}
              sx={{
                position: 'absolute',
                left: '50%',
                marginLeft: '-12px',
              }}
            />
            <span style={{ visibility: 'hidden' }}>{label}</span>
          </>
        ) : (
          label
        )}
      </Button>
    );
  }
);

FormButton.displayName = 'FormButton';

export default FormButton;
